export default __webpack_public_path__ + "static/media/to_do_image.ca023e04.png";